const type = {
    TextBox : 1,
    SelectBox : 2,
    DateRange : 3,
    Tags : 4 ,
    AmountRange:5,
    Select2:6
}

export default type